import { normalizeApiError } from "app/common/api/normalizeApiError";
import * as WorkspaceCRUD from "app/crud/workspaces.crud";

export const actionTypes = {
  BOOTSTRAP_STARTED: "[WORKSPACES] BOOTSTRAP_STARTED",
  WORKSPACES_LOADED: "[WORKSPACES] WORKSPACES_LOADED",
  WORKSPACE_SELECTED: "[WORKSPACES] WORKSPACE_SELECTED",
  WORKSPACE_DETAILS_LOADED: "[WORKSPACES] WORKSPACE_DETAILS_LOADED",
  BOOTSTRAP_EMPTY: "[WORKSPACES] BOOTSTRAP_EMPTY",
  BOOTSTRAP_FAILED: "[WORKSPACES] BOOTSTRAP_FAILED",
  WORKSPACE_MEMBERSHIP_UPDATED: "[WORKSPACES] WORKSPACE_MEMBERSHIP_UPDATED",
  CLEAR_WORKSPACES: "[WORKSPACES] CLEAR_WORKSPACES",
  WORKSPACE_ACTIVE_CHANGED: "[WORKSPACES] ACTIVE_CHANGED",
};

export const isUsableWorkspace = (workspace) =>
  workspace && workspace.disabled === false && workspace.workspaceDisabled === false;

function workspaceList(payload) {
  return Array.isArray(payload) ? payload : payload?.data || [];
}

export const bootstrapWorkspaces = () => async (dispatch, getState) => {
  dispatch({ type: actionTypes.BOOTSTRAP_STARTED });

  try {
    const { data } = await WorkspaceCRUD.getAvailableWorkspaces();
    const available = workspaceList(data);
    dispatch({ type: actionTypes.WORKSPACES_LOADED, payload: available });

    const persistedId =
      getState().workspaces.activeWorkspaceId || localStorage.getItem("active-workspace-id:v1");
    const selected =
      available.find(
        (workspace) => workspace.workspaceId === persistedId && isUsableWorkspace(workspace)
      ) || available.find(isUsableWorkspace);

    if (!selected) {
      dispatch({ type: actionTypes.BOOTSTRAP_EMPTY });
      return { available, selected: null };
    }

    await dispatch(selectWorkspace(selected.workspaceId));
    return { available, selected };
  } catch (error) {
    const normalized = normalizeApiError(error);
    dispatch({ type: actionTypes.BOOTSTRAP_FAILED, payload: normalized });
    return Promise.reject(normalized);
  }
};

export const selectWorkspace = (workspaceId) => async (dispatch, getState) => {
  const workspace = getState().workspaces.available.find(
    (item) => item.workspaceId === workspaceId
  );
  if (!isUsableWorkspace(workspace))
    return Promise.reject(new Error("Workspace is not available."));

  dispatch({ type: actionTypes.WORKSPACE_SELECTED, payload: workspaceId });
  dispatch({ type: actionTypes.WORKSPACE_ACTIVE_CHANGED });

  try {
    const { data } = await WorkspaceCRUD.getWorkspace();
    dispatch({ type: actionTypes.WORKSPACE_DETAILS_LOADED, payload: data.data });
    return data.data;
  } catch (error) {
    const normalized = normalizeApiError(error);
    dispatch({ type: actionTypes.BOOTSTRAP_FAILED, payload: normalized });
    return Promise.reject(normalized);
  }
};

export const recoverWorkspaceAccess = () => async (dispatch) => {
  return dispatch(bootstrapWorkspaces());
};
